import { useEffect, useState } from 'react';
import { Card, Box, Typography, Grid } from "@mui/material";
import SupplierSelectComponent from '../../supplier-select-component/SupplierSelectComponent';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import "./asn-supplier-summary.css";
import axios from 'axios';
import { useOktaAuth } from '@okta/okta-react';
import moment from 'moment';

const AsnSupplierSummary = (props) => {
    const { handleKeyDown, usertype, supplierList, userid, username } = props;
    const [supplierNumber, setSupplierNumber] = useState(null);
    const [supplierName, setSupplierName] = useState(null);
    const [supplierTestSummary, setsupplierTestSummary] = useState([]);
    const [totalTime, setTotalTime] = useState(null);
    const [totalSingleTime, setTotalSingleTime] = useState(null);
    const [totalMixedMasterTime, setTotalMixedMasterTime] = useState(null);
    const [summaryCardShow, setSummaryCardShow] = useState(false);
    const [noRecordMessage, setNoRecordMessage] = useState(true);
    const { oktaAuth } = useOktaAuth();

    const greenicon = < CheckCircleIcon color="success" />
    const redicon = <ReportIcon sx={{ color: '#c21020' }} />

    const supplierChangeHandler = (event) => {
        setSupplierNumber(event.slice(0, 10));
        setSupplierName(event.slice(13));
        setSummaryCardShow(true);
    }
    useEffect(() => {
        if (supplierNumber) {
            supplierTestSummaryDetails()
        }
    }, [supplierNumber])

    const supplierTestSummaryDetails = async () => {
        setNoRecordMessage(false)
        await axios.get(process.env.REACT_APP_API_BASE_URL + `/getSupplierAsnTestSummary?userId=${supplierNumber}`, {
            headers: {
                'Authorization': 'Bearer ' + oktaAuth.getAccessToken()
            }
        })
            .then((response) => {
                let temp = response?.data[0]
                setsupplierTestSummary(temp)
                let time1 = temp.entirelasttimetested === null ? '---' : moment(temp.entirelasttimetested).format('DD-MMM-YYYY')
                let time2 = temp.singlelasttimetested === null ? '---' : moment(temp.singlelasttimetested).format('DD-MMM-YYYY')
                let time3 = temp.mixedmasterlasttimetested === null ? '---' : moment(temp.mixedmasterlasttimetested).format('DD-MMM-YYYY')
                setTotalTime(time1)
                setTotalSingleTime(time2)
                setTotalMixedMasterTime(time3)

            })
            .catch((error) => {
                console.log(error);
            })
    };

    return (
        <div>
            <Typography gutterBottom variant="h2" component="h2">
                <span className='cardcontain'>ASN Supplier Summary  {summaryCardShow && <>for {supplierName} - {supplierNumber}</>}</span>
            </Typography>
            <Card className='cardcontainers cardcontain'>
                <Typography variant="h3" fontWeight="semibold" component="p" gutterBottom>
                    Supplier <span style={{ color: "red" }}>*</span>
                </Typography>
                <SupplierSelectComponent
                    userType={usertype}
                    supplierList={supplierList}
                    supplierChangeHandler={supplierChangeHandler}
                    handleKeyDown={handleKeyDown}
                />
            </Card>
            <br />
            {noRecordMessage &&
                <Box sx={{ "textAlign": "left", "padding-top": "4rem", "padding-left": "5rem" }}>
                    <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                        Select the Supplier number
                    </Typography>
                </Box>
            }
            {summaryCardShow &&
                <Grid className="grid-example" container >
                    <Grid item xs={4}>
                        <Box p={4}>
                            <Card className="paddingcontainer ">
                                <Typography size="md" component="p" gutterBottom>
                                    ASN Compliance Certification
                                </Typography>
                                <Typography size="md" fontWeight="semibold" component="p" gutterBottom>
                                    <>
                                        {supplierTestSummary.totaltests === 0 ? 'Testing Result Unavailable' :
                                            <> {supplierTestSummary.tsforcompletemaxtest === "N" ? redicon : greenicon}  {supplierTestSummary.tsforcompletemaxtest === "N" ? 'Not Compliant' : 'Compliant'}
                                            </>}
                                    </>
                                </Typography>
                                <Typography size="xs" component="p" gutterBottom>
                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Based on latest test submitted on {totalTime} by {username}-{userid}
                                </Typography><br />
                                <Grid className="grid-example bottomcard" container fontSize="15px">
                                    <Grid item sm={8} xs={12}>
                                        <Box p={4}> Total Test Submitted </Box>
                                    </Grid>
                                    <Grid item sm={4} xs={12} textAlign="right">
                                        <Box p={4}> {supplierTestSummary.totaltests} </Box>
                                    </Grid>
                                    <Typography size="xs" component="p" gutterBottom>
                                        &nbsp; &nbsp; &nbsp;(Combine single and master/mixed)
                                    </Typography>
                                </Grid>

                            </Card>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <Box p={4}>
                            <Card className="paddingcontainer">
                                <Typography size="md" component="p" gutterBottom>
                                    Single ASN Test Results
                                </Typography>
                                <Typography size="md" fontWeight="semibold" component="p" gutterBottom>
                                    <>
                                        {supplierTestSummary.totalsingletestcount === 0 ? 'Testing Result Unavailable' :
                                            <> {supplierTestSummary.tsforsingletest === "N" ? redicon : greenicon}  {supplierTestSummary.tsforsingletest === "N" ? 'Not Compliant' : 'Compliant'}
                                            </>}
                                    </>
                                </Typography>
                                <Typography size="xs" component="p" gutterBottom>
                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Based on latest test submitted on {totalSingleTime} by {username}-{userid}
                                </Typography><br />
                                <Grid className="grid-example" container fontSize="15px">
                                    <Grid item sm={6} xs={12} >
                                        <Box p={4}> Compliant Test </Box>
                                    </Grid>
                                    <Grid item sm={6} xs={12} textAlign="right" >
                                        <Box p={4}> {supplierTestSummary.singlecomplaint} </Box>
                                    </Grid>
                                </Grid><hr />
                                <Grid className="grid-example" container fontSize="15px">
                                    <Grid item sm={6} xs={12}>
                                        <Box p={4}>Not Compliant Test</Box>
                                    </Grid>
                                    <Grid item sm={6} xs={12} textAlign="right">
                                        <Box p={4}>{supplierTestSummary.singlenotcomplaint}</Box>
                                    </Grid>
                                </Grid><hr />
                                <Grid className="grid-example" container fontSize="15px">
                                    <Grid item sm={6} xs={12}>
                                        <Box p={4}>Total Test Submitted</Box>
                                    </Grid>
                                    <Grid item sm={6} xs={12} textAlign="right">
                                        <Box p={4}>{supplierTestSummary.totalsingletestcount}</Box>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <Box p={4}>
                            <Card className="paddingcontainer">
                                <Typography size="md" component="p" gutterBottom>
                                    Mixed/Master ASN Test Results
                                </Typography>
                                <Typography size="md" fontWeight="semibold" component="p" gutterBottom>
                                    <>
                                        {supplierTestSummary.totalmixedmastertestcount === 0 ? 'Testing Result Unavailable' :
                                            <> {supplierTestSummary.tsformixedmastertest === "N" ? redicon : greenicon}  {supplierTestSummary.tsformixedmastertest === "N" ? 'Not Compliant' : 'Compliant'}
                                            </>}
                                    </>

                                </Typography>
                                <Typography size="xs" component="p" gutterBottom>
                                    &nbsp; &nbsp; &nbsp; &nbsp;  Based on latest test submitted on {totalMixedMasterTime} by {username}-{userid}
                                </Typography><br />
                                <Grid className="grid-example" container fontSize="15px">
                                    <Grid item sm={6} xs={12} >
                                        <Box p={4}> Compliant Test </Box>
                                    </Grid>
                                    <Grid item sm={6} xs={12} textAlign="right" >
                                        <Box p={4}> {supplierTestSummary.mixedmastercomplaint} </Box>
                                    </Grid>
                                </Grid><hr />
                                <Grid className="grid-example" container fontSize="15px">
                                    <Grid item sm={6} xs={12}>
                                        <Box p={4}>Not Compliant Test</Box>
                                    </Grid>
                                    <Grid item sm={6} xs={12} textAlign="right">
                                        <Box p={4}>{supplierTestSummary.mixedmasternotcomplaint}</Box>
                                    </Grid>
                                </Grid><hr />
                                <Grid className="grid-example" container fontSize="15px">
                                    <Grid item sm={6} xs={12}>
                                        <Box p={4}>Total Test Submitted</Box>
                                    </Grid>
                                    <Grid item sm={6} xs={12} textAlign="right">
                                        <Box p={4}>{supplierTestSummary.totalmixedmastertestcount}</Box>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Box>
                    </Grid>
                </Grid>}

        </div>
    )
}

export default AsnSupplierSummary
